export default __webpack_public_path__ + "static/media/videocam_white_48dp.218d1886.svg";